import { ChevronLeft, ChevronRight } from 'lucide-react';
import { copy } from '../lib/copy';

type ClientPaginationProps = {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
};

export function ClientPagination({
  page,
  pageSize,
  total,
  onPageChange,
}: ClientPaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const start = total === 0 ? 0 : page * pageSize + 1;
  const end = Math.min(total, (page + 1) * pageSize);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-ops-border px-4 py-3">
      <p className="text-sm text-ops-muted">
        {total === 0 ? copy.pagination.empty : copy.pagination.range(start, end, total)}
      </p>
      <div className="flex gap-2">
        <button
          type="button"
          className="ops-btn-secondary py-2 text-sm"
          disabled={page <= 0}
          onClick={() => onPageChange(page - 1)}
        >
          <ChevronLeft className="h-4 w-4" />
          {copy.common.previous}
        </button>
        <button
          type="button"
          className="ops-btn-secondary py-2 text-sm"
          disabled={page >= totalPages - 1}
          onClick={() => onPageChange(page + 1)}
        >
          {copy.common.next}
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}

export function paginate<T>(items: T[], page: number, pageSize: number): T[] {
  const start = page * pageSize;
  return items.slice(start, start + pageSize);
}
